class GoTop {
    static attach(triggerSelector) {
        const triggerElement = document.querySelector(triggerSelector);
        if (triggerElement) {
            triggerElement.addEventListener("click", () => {
                GoTop.goTop();
            });
        }
    }

    static goTop() {
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    }
}

export { GoTop };
